import { apiRequest } from './client';

/** Product feedback (SRS #106). */

const TOKEN_KEY = 'policyora_token';
const opts = (extra: RequestInit = {}): RequestInit => {
  const token = localStorage.getItem(TOKEN_KEY);
  return { ...extra, headers: { ...(token ? { Authorization: `Bearer ${token}` } : {}), ...(extra.headers || {}) } };
};

export type FeedbackKind = 'feature' | 'nps' | 'bug' | 'idea';
export type FeedbackStatus = 'new' | 'reviewed' | 'planned' | 'done' | 'dismissed';
export interface FeedbackItem {
  id: number; user_id: number | null; user_email: string | null; kind: FeedbackKind | 'chat'; rating: number | null;
  comment: string | null; page: string | null; feature: string | null; message_id: number | null; meta: Record<string, unknown> | null;
  status: FeedbackStatus; admin_notes: string | null; reviewed_by: string | null; reviewed_at: string | null; created_at: string | null;
}
export interface FeedbackSummary {
  days: number; total: number; by_kind: Record<string, number>; by_status: Record<FeedbackStatus, number>;
  nps: { score: number | null; responses: number; promoters: number; detractors: number; passives: number };
  features: { feature: string; responses: number; avg_rating: number }[];
  chat: { up: number; down: number; helpful_pct: number | null };
  unhelpful_replies: { message_id: number; question: string; reply: string; why: string | null; at: string | null }[];
}

export const sendFeedback = (p: { kind: FeedbackKind; rating?: number; comment?: string; page?: string; feature?: string }) =>
  apiRequest<{ id: number; thanks: boolean }>('/api/v1/feedback', opts({ method: 'POST', body: JSON.stringify(p) }));
export const npsDue = () => apiRequest<{ due: boolean }>('/api/v1/feedback/nps-due', opts());
export const adminFeedbackSummary = (days = 90) => apiRequest<FeedbackSummary>(`/api/v1/admin/feedback/summary?days=${days}`, opts());
export const adminFeedbackList = (p: { kind?: string; status?: string; feature?: string; max_rating?: number; limit?: number } = {}) => {
  const q = new URLSearchParams();
  Object.entries(p).forEach(([k, v]) => { if (v !== undefined && v !== '') q.set(k, String(v)); });
  const s = q.toString();
  return apiRequest<{ items: FeedbackItem[]; kinds: string[]; statuses: FeedbackStatus[] }>(`/api/v1/admin/feedback${s ? `?${s}` : ''}`, opts());
};
export const adminFeedbackTriage = (id: number, p: { status?: FeedbackStatus; admin_notes?: string }) =>
  apiRequest<FeedbackItem>(`/api/v1/admin/feedback/${id}`, opts({ method: 'PATCH', body: JSON.stringify(p) }));

export async function downloadFeedbackCsv(): Promise<void> {
  const apiUrl = process.env.REACT_APP_API_BASE_URL ?? '';
  const res = await fetch(`${apiUrl}/api/v1/admin/feedback.csv`, opts());
  if (!res.ok) throw new Error(`Download failed (${res.status})`);
  const href = URL.createObjectURL(await res.blob());
  const a = document.createElement('a'); a.href = href; a.download = 'policyora-feedback.csv';
  document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(href);
}
